import { TypographyOptions } from "@mui/material/styles/createTypography";

export const typographies: TypographyOptions = {
  allVariants: {
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  title: {
    fontWeight: 600,
    fontSize: "28px",
    lineHeight: 1.235,
    letterSpacing: "0.00735em",
    fontFamily: ["Roboto", "Helvetica", "Arial"].join(","),
    margin: 0,
    marginBottom: "0.35em",
  },
  sectionTitle: {
    fontWeight: 500,
    fontSize: "19px",
    lineHeight: "26px",
    letterSpacing: "0.0075em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  tagText: {
    fontWeight: 600,
    fontSize: "19px",
    lineHeight: "26px",
    letterSpacing: "0.005em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  storeName: {
    fontWeight: 500,
    fontSize: "19px",
    lineHeight: "26px",
    letterSpacing: "0.5em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  titleRegistry: {
    color: "#53566F",
    fontWeight: 900,
    fontSize: "22px",
    lineHeight: "24px",
    letterSpacing: "0.02em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  storeNameLight: {
    color: "#124094", // blue brand light
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0.02em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  mainSectionNav: {
    color: "#124094", // blue brand light
    fontWeight: 800,
    fontSize: "22px",
    lineHeight: "24px",
    letterSpacing: "0.04em",
    textTransform: "capitalize",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  onboardingDialog: {
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "26px",
    letterSpacing: "0.005em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  onboardingDialogLight: {
    fontWeight: 400,
    fontSize: "22px",
    lineHeight: "26px",
    letterSpacing: "0.005em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  bigText: {
    fontWeight: 400,
    fontSize: "28px",
    lineHeight: "30px",
    letterSpacing: "0.01em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  bigTextLight: {
    color: "#000000",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "34px",
    letterSpacing: "0.01em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  previewText: {
    color: "#000000",
    fontWeight: 300,
    fontSize: "21px",
    lineHeight: "24px",
    letterSpacing: "0.005em",
    textTransform: "uppercase",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  buttonText: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.5px",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  pageAndProductTitle: {
    fontWeight: 400,
    fontSize: "19px",
    lineHeight: "26px",
    letterSpacing: "0.0075em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },

  textField: {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: "0.005em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  generalText: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "21px",
    letterSpacing: "0.5px",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  generalTextSmall: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "18px",
    letterSpacing: "0.005em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  miniatureText: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: "14px",
    letterSpacing: "0.3px",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  miniatureTextLight: {
    fontWeight: 400,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "0.25px",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  microTextLight: {
    fontWeight: 400,
    fontSize: "10px",
    lineHeight: "14px",
    letterSpacing: "0.3px",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  productNameThumbnailSmall: {
    fontWeight: 500,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "0.5px",
    textTransform: "capitalize",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  productNameThumbnailBig: {
    fontWeight: 400,
    fontSize: "17px",
    lineHeight: "22px",
    letterSpacing: "1px",
    textTransform: "capitalize",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  priceStrikeThrough: {
    fontWeight: 400,
    fontSize: "12.5px",
    lineHeight: "18px",
    letterSpacing: "1px",
    textDecorationLine: "line-through",
    textTransform: "capitalize",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  clarificationText: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "1px",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
  tagTextPressed: {
    fontWeight: 700,
    fontSize: "12px",
    lineHeight: "26px",
    letterSpacing: "0.005em",
    fontFamily: ["Lato", "Roboto", "Arial"].join(","),
  },
};
